import React, { useEffect, useRef } from 'react';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import L from 'leaflet';
import 'leaflet-draw';

const GeometryEditorMap = ({ onGeometryChange, expectedGeometryType, basemap }) => {
    const mapRef = useRef(null);
    const drawnItemsRef = useRef(null);
    const tileLayerRef = useRef(null);

    useEffect(() => {
        const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
        });

        const streetLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });

        if (!mapRef.current) {
            mapRef.current = L.map('map', {
                center: [3.1390, 101.6869], // Default to Kuala Lumpur
                zoom: 13,
                layers: [basemap === 'satellite' ? satelliteLayer : streetLayer]
            });

            tileLayerRef.current = basemap === 'satellite' ? satelliteLayer : streetLayer;

            drawnItemsRef.current = new L.FeatureGroup();
            mapRef.current.addLayer(drawnItemsRef.current);

            const drawControl = new L.Control.Draw({
                edit: {
                    featureGroup: drawnItemsRef.current
                },
                draw: {
                    polygon: expectedGeometryType === 'polygon',
                    polyline: expectedGeometryType === 'linestring',
                    marker: expectedGeometryType === 'point',
                    circle: false,
                    rectangle: false,
                    circlemarker: false
                }
            });
            mapRef.current.addControl(drawControl);

            mapRef.current.on(L.Draw.Event.CREATED, (event) => {
                const layer = event.layer;
                drawnItemsRef.current.clearLayers();
                drawnItemsRef.current.addLayer(layer);
                onGeometryChange(layer.toGeoJSON());
            });

            mapRef.current.on(L.Draw.Event.EDITED, () => {
                const layers = drawnItemsRef.current.getLayers();
                if (layers.length > 0) {
                    onGeometryChange(layers[0].toGeoJSON());
                }
            });

            mapRef.current.on(L.Draw.Event.DELETED, () => {
                onGeometryChange(null);
            });
        }
    }, [onGeometryChange, expectedGeometryType]);

    useEffect(() => {
        if (mapRef.current) {
            const newLayer = basemap === 'satellite'
                ? L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                })
                : L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                });

            if (tileLayerRef.current) {
                mapRef.current.removeLayer(tileLayerRef.current);
            }
            mapRef.current.addLayer(newLayer);
            tileLayerRef.current = newLayer;
        }
    }, [basemap]);

    return <div id="map" style={{ height: '500px', width: '100%' }} />;
};

export default GeometryEditorMap;